<i #icon [ngClass]="iconClasses"></i>
